import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { ChartsModule } from "ng2-charts";
import { ReactiveFormsModule } from "@angular/forms";
import { DigitOnlyModule } from "@uiowa/digit-only";
import { MatSliderModule } from "@angular/material/slider";

import {
  TrapFocusDirective,
  AutofocusDirective,
  ZoneDirective,
} from "@/shared-module/directives";

import {
  TopMenuComponent,
  NotAccessibleDialogComponent,
  HeaderComponent,
  DecisionSendComponent,
  DecisionSendDialogComponent,
  DialogComponent,
  FooterComponent,
  RecorderComponent,
  SliderComponent,
  SliderPanelComponent,
  SliderSelectComponent,
  SubmenuComponent,
  ZoneErrorComponent,
  ZoneContainerComponent,
  ZoneSample1Component,
  ZoneSample2Component,
  ZonePanelComponent,
  LanguageSelectionDialogComponent,
  LineChartComponent,
  BubbleChartComponent,
  MultiChartComponent,
  DonutChartComponent,
  StackedChartComponent,
  WaterfallComponent,
  BigNumberComponent,
  RankComponent,
  RankIndicesComponent,
  TableComponent,
  TeamSelectorComponent,
  ProgressBarComponent,
  DecisionLineChartComponent,
  DecisionDonutChartComponent,
  DecisionProductRoceChartComponent,
  DecisionAllProductsRoceChartComponent,
  RoceChartComponent,
  DecisionWaterfallComponent,
  ColorChangeValueComponent,
  NeedHelpButtonComponent,
  DecisionStackedChartComponent,
  DecisionMultiChartComponent,
  LargeDecisionAllProductsRoceChartComponent,
  SubmenuSingleLevelComponent,
  TestDecisionsFooterComponent,
  CreateTestDecisionDialogComponent,
  DecisionBackToTeamDecisionComponent,
  RowHeaderComponent,
  CustomerPanelDialogComponent,
  PlaceHolderComponent,
  MultiChart2LevelsLegendComponent,
  RadarChartComponent,
  DecisionRadarChartComponent
} from "./components";

@NgModule({
  declarations: [
    TopMenuComponent,
    DecisionSendComponent,
    DecisionSendDialogComponent,
    DialogComponent,
    FooterComponent,
    RecorderComponent,
    SliderComponent,
    SliderPanelComponent,
    SliderSelectComponent,
    SubmenuComponent,
    HeaderComponent,
    ZoneErrorComponent,
    ZoneContainerComponent,
    ZoneSample1Component,
    ZoneSample2Component,
    ZonePanelComponent,
    NotAccessibleDialogComponent,
    LanguageSelectionDialogComponent,
    LineChartComponent,
    BubbleChartComponent,
    MultiChartComponent,
    DonutChartComponent,
    StackedChartComponent,
    WaterfallComponent,
    BigNumberComponent,
    RankComponent,
    RankIndicesComponent,
    TableComponent,
    TeamSelectorComponent,
    TrapFocusDirective,
    AutofocusDirective,
    ZoneDirective,
    ProgressBarComponent,
    DecisionLineChartComponent,
    DecisionDonutChartComponent,
    DecisionProductRoceChartComponent,
    DecisionAllProductsRoceChartComponent,
    RoceChartComponent,
    DecisionWaterfallComponent,
    ColorChangeValueComponent,
    NeedHelpButtonComponent,
    DecisionStackedChartComponent,
    DecisionMultiChartComponent,
    LargeDecisionAllProductsRoceChartComponent,
    SubmenuSingleLevelComponent,
    TestDecisionsFooterComponent,
    CreateTestDecisionDialogComponent,
    DecisionBackToTeamDecisionComponent,
    RowHeaderComponent,
    CustomerPanelDialogComponent,
    PlaceHolderComponent,
    MultiChart2LevelsLegendComponent,
    RadarChartComponent,
    DecisionRadarChartComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatSliderModule,
    NgbModule,
    DigitOnlyModule,
    ChartsModule,
    CommonModule,
    RouterModule,
  ],
  entryComponents: [
    LineChartComponent,
    BigNumberComponent,
    TableComponent,
    MultiChartComponent,
    RankComponent,
    RankIndicesComponent,
    TeamSelectorComponent,
    StackedChartComponent,
    WaterfallComponent,
    BubbleChartComponent,
    DonutChartComponent,
    RadarChartComponent,
  ],
  exports: [
    TopMenuComponent,
    DecisionSendComponent,
    DecisionSendDialogComponent,
    DialogComponent,
    FooterComponent,
    RecorderComponent,
    SliderComponent,
    SliderPanelComponent,
    SliderSelectComponent,
    SubmenuComponent,
    HeaderComponent,
    ZoneErrorComponent,
    ZoneContainerComponent,
    ZoneSample1Component,
    ZoneSample2Component,
    ZonePanelComponent,
    NotAccessibleDialogComponent,
    LanguageSelectionDialogComponent,
    LineChartComponent,
    BubbleChartComponent,
    MultiChartComponent,
    DonutChartComponent,
    StackedChartComponent,
    WaterfallComponent,
    BigNumberComponent,
    RankComponent,
    RankIndicesComponent,
    TableComponent,
    TeamSelectorComponent,
    TrapFocusDirective,
    AutofocusDirective,
    ZoneDirective,
    ProgressBarComponent,
    DecisionLineChartComponent,
    DecisionDonutChartComponent,
    DecisionProductRoceChartComponent,
    DecisionAllProductsRoceChartComponent,
    RoceChartComponent,
    DecisionWaterfallComponent,
    ColorChangeValueComponent,
    NeedHelpButtonComponent,
    DecisionStackedChartComponent,
    DecisionMultiChartComponent,
    LargeDecisionAllProductsRoceChartComponent,
    SubmenuSingleLevelComponent,
    TestDecisionsFooterComponent,
    CreateTestDecisionDialogComponent,
    DecisionBackToTeamDecisionComponent,
    RowHeaderComponent,
    CustomerPanelDialogComponent,
    RadarChartComponent,
    DecisionRadarChartComponent
  ],
})
export class SharedModuleModule {}
